var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business-and-finance 1",
    clipPath: "url(#clip0_220_3509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.9186 36.4315C44.7075 35.4153 44.1101 34.547 43.2363 33.9864C42.3626 33.4261 41.3247 33.2451 40.3126 33.4765L35.6221 34.5504V32.633C36.5628 31.7469 37.5423 30.5899 38.2389 29.5324C39.4605 27.6782 40.325 25.6419 40.8084 23.4814C41.3831 20.9109 41.3954 18.1897 40.8437 15.6111C40.7421 15.1366 40.2748 14.8338 39.8004 14.9357C39.3256 15.037 39.0234 15.5043 39.1247 15.9791C39.6239 18.3113 39.6129 20.7729 39.0928 23.0975C38.6561 25.0497 37.8747 26.8895 36.7709 28.5653C36.4437 29.0621 36.0468 29.5833 35.6221 30.0811V20.3389C35.6221 19.8535 35.2287 19.46 34.7432 19.46H27.7906V10.0743C27.7906 9.5902 27.3989 9.1971 26.9148 9.19538L19.0832 9.16895C19.0822 9.16895 19.0815 9.16895 19.0805 9.16895C18.8477 9.16895 18.6246 9.26096 18.4601 9.42541C18.2946 9.5902 18.2016 9.81405 18.2016 10.0479V14.9302H11.2479C10.7628 14.9302 10.369 15.3237 10.369 15.8091V24.5127H8.41072V23.319C8.41072 22.8339 8.01727 22.4404 7.53181 22.4404H6.63025C6.47678 21.5955 6.38786 20.7372 6.36692 19.8803C6.31542 17.7966 6.6457 15.758 7.34813 13.8203C7.5119 13.3685 7.69798 12.918 7.90088 12.482C8.10585 12.0419 7.91496 11.519 7.47516 11.314C7.03502 11.1097 6.51214 11.2999 6.30752 11.7401C6.08265 12.2228 5.87665 12.7213 5.69572 13.2212C4.91844 15.3652 4.55315 17.6205 4.60945 19.9235C4.63039 20.7654 4.71073 21.6079 4.84703 22.4404H0.878906C0.393448 22.4404 0 22.8339 0 23.3193V38.7682C0 39.2536 0.393448 39.6471 0.878906 39.6471H7.53181C8.01727 39.6471 8.41072 39.2536 8.41072 38.7682V37.9325H11.7169L25.1096 43.1854C26.36 43.676 27.6697 43.9228 28.9864 43.9228C29.8643 43.9228 30.7459 43.813 31.6142 43.5922L42.1113 40.9242C44.1039 40.4178 45.3368 38.4444 44.9186 36.4315ZM33.8647 21.2179V34.9528L31.515 35.4908C31.2623 35.5485 31.0068 35.5941 30.75 35.6299C29.7709 35.7648 28.7718 35.7363 27.803 35.5444C27.7988 35.5433 27.7947 35.5426 27.7906 35.5416V34.2088C28.4608 33.2091 28.6829 31.9415 28.3317 30.7845C28.2338 30.4618 28.0948 30.1504 27.918 29.8631C27.8778 29.7978 27.8359 29.734 27.7923 29.6715C27.792 29.6705 27.7913 29.6698 27.7906 29.6687V21.2175H33.8647V21.2179ZM19.9594 10.9298L26.0331 10.9501V28.2728L22.6387 26.8679L19.9594 25.7586V10.9298ZM12.1268 16.6881H18.2006V25.0305L17.1105 24.5793C17.0037 24.535 16.8894 24.5124 16.7744 24.5124H12.1268V16.6881ZM6.65291 37.8893H1.75781V24.1979H5.90446C5.90618 24.1979 5.90824 24.1982 5.9103 24.1982C5.91202 24.1982 5.91339 24.1979 5.91511 24.1979H6.65291V37.8893ZM41.6783 39.2207L31.1813 41.8886C29.3692 42.349 27.4916 42.2313 25.7513 41.5491L12.2041 36.2355C12.1018 36.1953 11.9929 36.175 11.8831 36.175H8.41072V26.2705H16.5993L22.2861 28.6244L25.398 29.9125C26.499 30.3691 27.026 31.6607 26.5745 32.7604C26.4839 32.9811 26.3716 33.1909 26.2226 33.378C25.6723 34.0725 24.7663 34.3788 23.9189 34.1728C23.9121 34.1711 23.9052 34.1694 23.8983 34.1676C23.8475 34.1549 23.7971 34.1402 23.7469 34.1237L17.8332 31.8502C17.7851 31.8317 17.7597 31.8221 17.7597 31.8221C17.3069 31.6477 16.7984 31.8739 16.624 32.3271C16.45 32.7799 16.6759 33.2887 17.1291 33.4628C17.1291 33.4628 20.4634 34.7448 23.0061 35.7253C23.0572 35.7452 23.108 35.7637 23.1592 35.7809L25.1117 36.5318C25.7018 36.7587 26.2892 36.9846 26.9035 37.1415C27.9465 37.4079 29.029 37.515 30.1042 37.4563C30.7106 37.4234 31.3158 37.3396 31.9077 37.2043L34.9396 36.5105C34.9427 36.5098 34.9458 36.5084 34.9489 36.5077L40.705 35.1901C41.2526 35.0647 41.8146 35.1626 42.2871 35.4657C42.7602 35.7692 43.0832 36.2393 43.1975 36.7893C43.4241 37.8786 42.7567 38.9467 41.6783 39.2207Z",
    fill: "#EDFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2395 7.3938C11.4496 7.3938 11.6604 7.31895 11.8283 7.1672C13.3965 5.75065 15.2694 4.62078 17.2452 3.89946C19.3858 3.11805 21.7324 2.78469 24.0317 2.93575C25.6772 3.0439 27.2894 3.39512 28.8234 3.97945C29.2766 4.15214 29.7847 3.92486 29.9574 3.47099C30.1304 3.01746 29.9028 2.50969 29.4489 2.337C27.7516 1.69018 25.9676 1.30153 24.147 1.18171C21.6057 1.01486 19.0106 1.38359 16.6423 2.24842C14.4564 3.0463 12.3844 4.29634 10.6503 5.86258C10.2898 6.18805 10.2617 6.74389 10.5871 7.10403C10.7605 7.29629 10.9995 7.3938 11.2395 7.3938Z",
    fill: "#EDFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.1911 13.6667C31.3576 13.8112 31.5629 13.8819 31.7672 13.8819C32.0127 13.8819 32.2571 13.7796 32.4312 13.5798L39.6623 5.25597C39.9809 4.88964 39.9417 4.33449 39.5754 4.01623C39.2087 3.69797 38.6539 3.73677 38.3357 4.10309L31.1043 12.4269C30.7857 12.7933 30.8248 13.3484 31.1911 13.6667Z",
    fill: "#EDFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.6714 9.9082C36.4546 9.9082 35.4648 10.898 35.4648 12.1147C35.4648 13.3315 36.4546 14.3213 37.6714 14.3213C38.8881 14.3213 39.8779 13.3311 39.8779 12.1147C39.8779 10.898 38.8881 9.9082 37.6714 9.9082ZM37.6714 12.5635C37.4238 12.5635 37.2227 12.3623 37.2227 12.1147C37.2227 11.8675 37.4238 11.666 37.6714 11.666C37.9186 11.666 38.1201 11.8675 38.1201 12.1147C38.1201 12.3623 37.9186 12.5635 37.6714 12.5635Z",
    fill: "#EDFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.7905 7.95213C34.0073 7.95213 34.9971 6.96233 34.9971 5.7456C34.9971 4.52886 34.0073 3.53906 32.7905 3.53906C31.5738 3.53906 30.584 4.52886 30.584 5.7456C30.584 6.96233 31.5738 7.95213 32.7905 7.95213ZM32.7905 5.29653C33.0381 5.29653 33.2392 5.49806 33.2392 5.7456C33.2392 5.99279 33.0381 6.19432 32.7905 6.19432C32.543 6.19432 32.3418 5.99279 32.3418 5.7456C32.3418 5.49806 32.543 5.29653 32.7905 5.29653Z",
    fill: "#EDFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.11498 9.4589C8.25575 9.79673 8.60216 10.0199 8.96917 10.0007C9.33206 9.98178 9.64998 9.73631 9.76225 9.39161C9.87554 9.04383 9.75195 8.64763 9.46115 8.4255C9.16486 8.1996 8.74876 8.18552 8.43839 8.39186C8.09404 8.62085 7.95602 9.07747 8.11498 9.4589Z",
    fill: "#EDFBF9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39514",
    x: 11.4546,
    y: 16.3633,
    width: 7.36364,
    height: 8.18182,
    fill: "url(#paint0_linear_220_3509)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 39516",
    d: "M27 20.4541H34.3636V35.9996H27V20.4541Z",
    fill: "url(#paint1_linear_220_3509)",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 39515",
    d: "M19.6362 10.6367H26.1817V29.4549L19.6362 26.1822V10.6367Z",
    fill: "url(#paint2_linear_220_3509)",
    fillOpacity: 0.24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_3509",
    x1: 15.75,
    y1: 16.3633,
    x2: 15.75,
    y2: 25.7139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_220_3509",
    x1: 31.2955,
    y1: 20.4541,
    x2: 31.2955,
    y2: 38.2203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_220_3509",
    x1: 23.4544,
    y1: 10.6367,
    x2: 23.4544,
    y2: 32.1432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_3509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.4006ab022d1a1b198dbca20d957cef1b.svg";
export { ForwardRef as ReactComponent };